import { render, staticRenderFns } from "./DeliveryPoints.vue?vue&type=template&id=7763faa4&"
import script from "./DeliveryPoints.vue?vue&type=script&lang=ts&"
export * from "./DeliveryPoints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports